<template>
  <section class="abonnements-info mb-size-40">
    <div v-if="abonnementer.status.laster"><ods-spinner /> {{ $t('abonnementer.loading') }}</div>
    <div v-else-if="abonnementer.status.feiler" class="ok-alert ok-alert--icon ok-alert--danger" role="alert">
      {{ $t('abonnementer.error') }}
    </div>
    <template v-else-if="abonnementerUtenomEidAdresse.length > 0">
      <h2 class="ods-text--size-golf ods-margin-top-0 ods-margin-bottom-5 ods-text--size-charlie-breakpoint-medium">
        {{ $t('abonnementer.title') }}
      </h2>
      <div v-for="(abonnement, index) in abonnementerUtenomEidAdresse" :key="`abonnementerUtenomEidAdresse-${index}`">
        <aktive-abonnementer :abonnement="abonnement" />
      </div>
    </template>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import OdsSpinner from '@/global-components/OdsSpinner.vue';
import AktiveAbonnementer from './AktiveAbonnementer.vue';

export default {
  name: 'AbonnementsInfo',

  components: {
    AktiveAbonnementer,
    OdsSpinner,
  },

  computed: {
    ...mapGetters('abonnementer', ['abonnementerUtenomEidAdresse']),
    ...mapState(['abonnementer']),
    ...mapState('representasjoner', ['currentRepresentation']),
  },

  created() {
    this.getAbonnementerOgTyper();
  },

  methods: {
    ...mapActions(['addGlobalMessage']),
    ...mapActions('abonnementer', ['getAbonnementerOgTyper', 'getAbonnementstyper']),

    isExternalLink(url) {
      return url.slice(0, 4) === 'http';
    },
  },
};
</script>

<style lang="scss">
@use 'sass:map';

.abonnements-info {
  .div .inner-div:not(:last-child)::after {
    content: 'not in the bottom div';
  }
}
</style>
